export default __webpack_public_path__ + "static/media/xls.b92ebb2b.svg";